/* ═══════════════════════════════════
   CIA DA MALHA PIJAMAS — THEME JS
   Vanilla JS, zero dependencies
═══════════════════════════════════ */
(function () {
  'use strict';

  // Prevent duplicate listener registration if script is re-executed.
  if (window.__ciaThemeInitialized) return;
  window.__ciaThemeInitialized = true;

  function runWhenIdle(callback) {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(callback, { timeout: 1200 });
      return;
    }
    window.setTimeout(callback, 1);
  }

  function runWhenVisible(element, callback, options) {
    if (!element || typeof callback !== 'function') return;

    if (!('IntersectionObserver' in window)) {
      runWhenIdle(() => callback(element));
      return;
    }

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        obs.unobserve(entry.target);
        callback(entry.target);
      });
    }, options || {
      root: null,
      rootMargin: '220px 0px',
      threshold: 0.01
    });

    observer.observe(element);
  }

  // ─── CART DRAWER ───
  function getCartElements() {
    return {
      cartOverlay: document.getElementById('cart-overlay'),
      cartDrawer: document.getElementById('cart-drawer'),
      cartToggle: document.getElementById('cart-toggle')
    };
  }

  function openCart() {
    const { cartOverlay, cartDrawer, cartToggle } = getCartElements();
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    cartOverlay && cartOverlay.classList.add('open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    cartToggle && cartToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    renderCart();
  }

  function closeCart() {
    const { cartOverlay, cartDrawer, cartToggle } = getCartElements();
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartOverlay && cartOverlay.classList.remove('open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    cartToggle && cartToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  function openSearchPanel() {
    const panel = document.getElementById('search-panel');
    const overlay = document.getElementById('search-overlay');
    const toggle = document.getElementById('search-toggle');
    if (!panel || !toggle) return;
    panel.classList.add('open');
    panel.setAttribute('aria-hidden', 'false');
    if (overlay) {
      overlay.classList.add('open');
      overlay.setAttribute('aria-hidden', 'false');
    }
    toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    const input = document.getElementById('header-search-input');
    if (input) window.setTimeout(() => input.focus(), 60);
  }

  function closeSearchPanel() {
    const panel = document.getElementById('search-panel');
    const overlay = document.getElementById('search-overlay');
    const toggle = document.getElementById('search-toggle');
    if (!panel || !toggle) return;
    panel.classList.remove('open');
    panel.setAttribute('aria-hidden', 'true');
    if (overlay) {
      overlay.classList.remove('open');
      overlay.setAttribute('aria-hidden', 'true');
    }
    toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  function toggleSearchPanel() {
    const panel = document.getElementById('search-panel');
    if (!panel) return;
    if (panel.classList.contains('open')) closeSearchPanel();
    else openSearchPanel();
  }

  function openMobileMenu() {
    const menu = document.getElementById('mobile-menu');
    const overlay = document.getElementById('mobile-menu-overlay');
    const btn = document.getElementById('mobile-menu-btn');
    if (!menu || !btn) return;
    menu.classList.add('open');
    menu.setAttribute('aria-hidden', 'false');
    overlay && overlay.classList.add('open');
    overlay && overlay.setAttribute('aria-hidden', 'false');
    btn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    const menu = document.getElementById('mobile-menu');
    const overlay = document.getElementById('mobile-menu-overlay');
    const btn = document.getElementById('mobile-menu-btn');
    if (!menu || !btn) return;
    menu.classList.remove('open');
    menu.setAttribute('aria-hidden', 'true');
    overlay && overlay.classList.remove('open');
    overlay && overlay.setAttribute('aria-hidden', 'true');
    btn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  function toggleMobileMenu() {
    const menu = document.getElementById('mobile-menu');
    if (!menu) return;
    if (menu.classList.contains('open')) closeMobileMenu();
    else openMobileMenu();
  }

  function updateBackButtonVisibility() {
    const backBtn = document.getElementById('mobile-back-btn');
    if (!backBtn) return;
    // Hide back button on home page
    const isHomePage = window.location.pathname === '/' || window.location.pathname === '/index.html';
    if (isHomePage) {
      backBtn.classList.add('hidden');
      backBtn.setAttribute('aria-hidden', 'true');
    } else {
      backBtn.classList.remove('hidden');
      backBtn.setAttribute('aria-hidden', 'false');
    }
  }

  // Initialize back button visibility on page load
  updateBackButtonVisibility();
  // Update back button visibility on popstate (when user uses browser back button)
  window.addEventListener('popstate', updateBackButtonVisibility);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeCart();
      closeSearchPanel();
      closeMobileMenu();
    }
  });

  async function fetchCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  function formatMoney(cents) {
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
  }

  let latestCartState = null;

  function resetCouponFieldState() {
    const couponInput = document.getElementById('cart-coupon-input');
    if (!couponInput) return;

    couponInput.placeholder = 'Adicionar Cupom';
    couponInput.classList.remove('is-success');
    couponInput.classList.remove('is-error');
  }

  function setCouponFieldMessage(message, state) {
    const couponInput = document.getElementById('cart-coupon-input');
    if (!couponInput) return;

    couponInput.value = '';
    couponInput.placeholder = message;
    couponInput.classList.remove('is-success');
    couponInput.classList.remove('is-error');

    if (state === 'success') couponInput.classList.add('is-success');
    if (state === 'error') couponInput.classList.add('is-error');
  }

  function getDiscountSavings(cart) {
    const totalDiscount = Number(cart && cart.total_discount ? cart.total_discount : 0);
    if (totalDiscount > 0) return totalDiscount;

    const originalTotal = Number(cart && cart.original_total_price ? cart.original_total_price : 0);
    const currentTotal = Number(cart && cart.total_price ? cart.total_price : 0);
    return Math.max(0, originalTotal - currentTotal);
  }

  function getCartItemSize(item) {
    if (!item) return '';

    if (Array.isArray(item.options_with_values)) {
      const sizeOption = item.options_with_values.find((option) => /tamanho|size/i.test(String(option && option.name ? option.name : '')));
      if (sizeOption && sizeOption.value) return String(sizeOption.value);
    }

    if (Array.isArray(item.variant_options) && item.variant_options.length) {
      const lastOption = item.variant_options[item.variant_options.length - 1];
      if (lastOption) return String(lastOption);
    }

    const variantTitle = String(item.variant_title || '').trim();
    if (!variantTitle || /default title/i.test(variantTitle)) return '';

    const parts = variantTitle.split('/').map((part) => part.trim()).filter(Boolean);
    return parts.length ? parts[parts.length - 1] : variantTitle;
  }

  function getCartItemPriceHtml(item) {
    const grossLinePrice = Number(item && item.original_line_price ? item.original_line_price : 0);
    const finalLinePrice = Number(item && item.final_line_price ? item.final_line_price : 0);
    const finalUnitPrice = Number(item && item.final_price ? item.final_price : 0);

    const showDiscount = grossLinePrice > finalLinePrice;
    const grossHtml = showDiscount
      ? `<div class="cart-item-price-gross">${formatMoney(grossLinePrice)}</div>`
      : `<div class="cart-item-price-main">${formatMoney(finalLinePrice)}</div>`;
    const discountText = formatMoney(finalUnitPrice).replace(/\s*un\.?$/i, '');
    const discountHtml = showDiscount
      ? `<div class="cart-item-price-discount">${discountText}</div>`
      : '';

    return `${grossHtml}${discountHtml}`;
  }

  function updateCartSavingsSummary(cart) {
    const grossEl = document.getElementById('cart-gross-total');
    const discountEl = document.getElementById('cart-discount-savings');

    if (!grossEl || !discountEl) return;

    const discountSavings = getDiscountSavings(cart);
    const grossTotal = Number(cart && cart.original_total_price ? cart.original_total_price : 0);
    const displayGross = grossTotal > 0 ? grossTotal : Number(cart && cart.total_price ? cart.total_price : 0);
    const pendingCouponCode = sessionStorage.getItem('ciaPendingDiscountCode');

    grossEl.textContent = formatMoney(displayGross);
    discountEl.textContent = `-${formatMoney(discountSavings)}`;

    const activeDiscounts = Array.isArray(cart.cart_level_discount_applications)
      ? cart.cart_level_discount_applications
      : [];
    const discountNames = activeDiscounts
      .map((discount) => discount && discount.title ? discount.title : '')
      .filter(Boolean)
      .join(', ');

    if (pendingCouponCode) {
      if (discountSavings > 0) {
        setCouponFieldMessage(
          discountNames
          ? `Cupom aplicado: ${discountNames}`
          : `Cupom aplicado: ${pendingCouponCode}`,
          'success'
        );
      } else {
        setCouponFieldMessage('Cupom inválido ou não elegível para este carrinho.', 'error');
      }
      sessionStorage.removeItem('ciaPendingDiscountCode');
      return;
    }

    if (discountSavings > 0 && discountNames) {
      setCouponFieldMessage(`Cupom ativo: ${discountNames}`, 'success');
    } else {
      resetCouponFieldState();
    }
  }

  async function applyCouponCode(code) {
    const coupon = String(code || '').trim();
    if (!coupon) return null;

    const redirectTarget = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    sessionStorage.setItem('ciaPendingDiscountCode', coupon);
    sessionStorage.setItem('ciaOpenCartAfterDiscount', '1');
    window.location.assign(`/discount/${encodeURIComponent(coupon)}?redirect=${encodeURIComponent(redirectTarget)}`);
    return null;
  }

  let currentShippingCost = 0;
  let currentShippingMeta = {
    serviceName: 'Frete',
    deliveryText: ''
  };

  function hasFreeShipping(cartTotal) {
    const freeShippingThreshold = Number(window.__ciaThemeSettings?.freeShippingThreshold || 25000);
    return Number(cartTotal) > 0 && Number(cartTotal) >= freeShippingThreshold;
  }

  function resetShippingFieldState() {
    const cepInput = document.getElementById('cart-shipping-cep');
    if (!cepInput) return;

    cepInput.placeholder = 'Calcular Frete';
    cepInput.classList.remove('is-success');
    cepInput.classList.remove('is-error');
  }

  function setShippingFieldMessage(message, state) {
    const cepInput = document.getElementById('cart-shipping-cep');
    const shippingFeedback = document.getElementById('cart-shipping-feedback');
    if (!cepInput) return;

    cepInput.value = '';
    cepInput.placeholder = message;
    cepInput.classList.remove('is-success');
    cepInput.classList.remove('is-error');

    if (state === 'success') cepInput.classList.add('is-success');
    if (state === 'error') cepInput.classList.add('is-error');

    if (shippingFeedback) {
      shippingFeedback.textContent = message;
      shippingFeedback.classList.toggle('success', state === 'success');
      shippingFeedback.classList.toggle('error', state === 'error');
    }
  }

  function parseShippingPriceToCents(rawPrice) {
    if (rawPrice == null || rawPrice === '') return 0;

    if (typeof rawPrice === 'string') {
      const normalized = rawPrice.replace(',', '.').trim();
      const parsed = Number.parseFloat(normalized);
      if (Number.isNaN(parsed)) return 0;
      return Math.round(parsed * 100);
    }

    const numeric = Number(rawPrice);
    if (Number.isNaN(numeric)) return 0;
    if (!Number.isInteger(numeric)) return Math.round(numeric * 100);
    if (numeric < 1000) return numeric * 100;
    return numeric;
  }

  function getShippingServiceName(rate) {
    return rate.name || rate.service_name || rate.presentment_name || 'Frete';
  }

  function getShippingDeliveryText(rate) {
    const range = Array.isArray(rate.delivery_range) ? rate.delivery_range : [];
    if (range.length >= 2 && Number(range[0]) > 0 && Number(range[1]) > 0) {
      return `Prazo: ${range[0]} a ${range[1]} dias uteis`;
    }
    if (range.length === 1 && Number(range[0]) > 0) {
      return `Prazo: ate ${range[0]} dias uteis`;
    }

    if (rate.delivery_date) {
      const date = new Date(rate.delivery_date);
      if (!Number.isNaN(date.getTime())) {
        const formatted = date.toLocaleDateString('pt-BR');
        return `Entrega estimada: ${formatted}`;
      }
    }

    return '';
  }

  function getShippingRatesQuery(zipCode, addressData) {
    const params = new URLSearchParams();
    params.set('shipping_address[zip]', zipCode);
    params.set('shipping_address[country]', 'Brazil');
    params.set('shipping_address[country_code]', 'BR');

    if (addressData && addressData.province) {
      params.set('shipping_address[province]', addressData.province);
      params.set('shipping_address[province_code]', addressData.province);
    }

    if (addressData && addressData.city) {
      params.set('shipping_address[city]', addressData.city);
    }

    return params.toString();
  }

  function normalizeShippingRatesResponse(data) {
    if (Array.isArray(data)) return data;
    if (Array.isArray(data && data.shipping_rates)) return data.shipping_rates;
    return [];
  }

  function wait(ms) {
    return new Promise((resolve) => window.setTimeout(resolve, ms));
  }

  function summarizePayload(payload) {
    if (payload == null) return '';
    const raw = typeof payload === 'string' ? payload : JSON.stringify(payload);
    return raw.length > 500 ? `${raw.slice(0, 500)}...` : raw;
  }

  async function readResponsePayload(response) {
    const text = await response.text();
    let json = null;
    try {
      json = text ? JSON.parse(text) : null;
    } catch (error) {
      json = null;
    }

    return {
      ok: response.ok,
      status: response.status,
      statusText: response.statusText,
      url: response.url,
      json,
      text
    };
  }

  function logShippingDebug(debugInfo) {
    window.__ciaShippingDebug = debugInfo;
    console.groupCollapsed('[CART FRETE DEBUG]');
    console.log(debugInfo);
    console.groupEnd();
  }

  function buildShippingError(message, debugInfo) {
    const error = new Error(message);
    error.details = debugInfo;
    return error;
  }

  async function fetchAddressFromZip(zipCode, debugInfo) {
    try {
      const response = await fetch(`https://viacep.com.br/ws/${zipCode}/json/`, {
        method: 'GET'
      });

      if (!response.ok) {
        debugInfo.steps.push({
          stage: 'viacep_lookup',
          ok: false,
          status: response.status,
          statusText: response.statusText,
          message: 'Falha ao consultar ViaCEP'
        });
        return null;
      }

      const data = await response.json();
      if (data && data.erro) {
        debugInfo.steps.push({
          stage: 'viacep_lookup',
          ok: false,
          message: 'CEP não encontrado no ViaCEP'
        });
        return null;
      }

      const addressData = {
        province: data && data.uf ? String(data.uf).trim() : '',
        city: data && data.localidade ? String(data.localidade).trim() : ''
      };

      debugInfo.steps.push({
        stage: 'viacep_lookup',
        ok: true,
        province: addressData.province,
        city: addressData.city
      });

      return addressData;
    } catch (error) {
      debugInfo.steps.push({
        stage: 'viacep_lookup_exception',
        message: error && error.message ? error.message : 'Erro desconhecido no ViaCEP'
      });
      return null;
    }
  }

  async function calculateShipping(cep) {
    const zipCode = String(cep || '').replace(/\D/g, '').trim();
    const debugInfo = {
      timestamp: new Date().toISOString(),
      zipCode,
      steps: []
    };

    if (zipCode.length !== 8) {
      debugInfo.steps.push({ stage: 'validation', message: 'CEP com tamanho inválido' });
      logShippingDebug(debugInfo);
      throw buildShippingError('CEP inválido. Digite 8 dígitos.', debugInfo);
    }

    const cart = latestCartState || (await fetchCart());
    if (!cart || cart.item_count === 0) {
      debugInfo.steps.push({ stage: 'validation', message: 'Carrinho vazio' });
      logShippingDebug(debugInfo);
      throw buildShippingError('Carrinho vazio.', debugInfo);
    }

    const addressData = await fetchAddressFromZip(zipCode, debugInfo);
    const query = getShippingRatesQuery(zipCode, addressData);
    debugInfo.addressData = addressData;
    debugInfo.query = query;
    let shippingRates = [];

    try {
      const directResponse = await fetch(`/cart/shipping_rates.json?${query}`, {
        method: 'GET',
        credentials: 'same-origin'
      });

      const directPayload = await readResponsePayload(directResponse);
      debugInfo.steps.push({
        stage: 'direct_shipping_rates',
        ok: directPayload.ok,
        status: directPayload.status,
        statusText: directPayload.statusText,
        payload: summarizePayload(directPayload.json || directPayload.text)
      });

      if (directPayload.ok) {
        shippingRates = normalizeShippingRatesResponse(directPayload.json);
      }
    } catch (error) {
      debugInfo.steps.push({
        stage: 'direct_shipping_rates_exception',
        message: error && error.message ? error.message : 'Erro desconhecido no fetch direto'
      });
      shippingRates = [];
    }

    if (!shippingRates.length) {
      const prepareResponse = await fetch('/cart/prepare_shipping_rates.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        body: query,
        credentials: 'same-origin'
      });

      const preparePayload = await readResponsePayload(prepareResponse);
      debugInfo.steps.push({
        stage: 'prepare_shipping_rates',
        ok: preparePayload.ok,
        status: preparePayload.status,
        statusText: preparePayload.statusText,
        payload: summarizePayload(preparePayload.json || preparePayload.text)
      });

      if (!preparePayload.ok) {
        logShippingDebug(debugInfo);
        throw buildShippingError('Não foi possível iniciar o cálculo de frete. Verifique o CEP.', debugInfo);
      }

      for (let attempt = 0; attempt < 20; attempt += 1) {
        await wait(700);

        const asyncResponse = await fetch(`/cart/async_shipping_rates.json?${query}`, {
          method: 'GET',
          credentials: 'same-origin'
        });

        const asyncPayload = await readResponsePayload(asyncResponse);
        const asyncRates = normalizeShippingRatesResponse(asyncPayload.json);

        debugInfo.steps.push({
          stage: 'async_shipping_rates',
          attempt: attempt + 1,
          ok: asyncPayload.ok,
          status: asyncPayload.status,
          statusText: asyncPayload.statusText,
          ratesCount: asyncRates.length,
          payload: summarizePayload(asyncPayload.json || asyncPayload.text)
        });

        if (!asyncPayload.ok) {
          continue;
        }

        shippingRates = asyncRates;

        if (shippingRates.length) break;
      }
    }

    if (shippingRates.length === 0) {
      logShippingDebug(debugInfo);
      throw buildShippingError('Frete indisponível para este CEP.', debugInfo);
    }

    const ratesWithCents = shippingRates
      .map((rate) => ({
        rate,
        cents: parseShippingPriceToCents(rate && rate.price)
      }))
      .filter((entry) => entry.cents >= 0);

    if (!ratesWithCents.length) {
      logShippingDebug(debugInfo);
      throw buildShippingError('Nao foi possivel interpretar o valor do frete retornado.', debugInfo);
    }

    ratesWithCents.sort((a, b) => a.cents - b.cents);

    const cheapest = ratesWithCents[0].rate;
    const shippingPrice = ratesWithCents[0].cents;
    const serviceName = getShippingServiceName(cheapest);
    const deliveryText = getShippingDeliveryText(cheapest);

    debugInfo.result = {
      ratesCount: shippingRates.length,
      cheapestRateName: serviceName,
      deliveryText,
      rawPrice: cheapest && cheapest.price ? cheapest.price : null,
      shippingPriceCents: shippingPrice
    };
    logShippingDebug(debugInfo);

    currentShippingCost = shippingPrice;
    currentShippingMeta = {
      serviceName,
      deliveryText
    };

    return {
      priceCents: shippingPrice,
      serviceName,
      deliveryText
    };
  }

  function updateInstallmentDisplay(finalTotal) {
    const installCountEl = document.getElementById('installment-count');
    const installValueEl = document.getElementById('installment-value');

    if (!installCountEl || !installValueEl) return;

    const maxInstallments = 6;
    const installValue = finalTotal / maxInstallments;

    installCountEl.textContent = String(maxInstallments);
    installValueEl.textContent = formatMoney(Math.round(installValue));
  }

  function updateCartTotal() {
    const subtotalEl = document.getElementById('cart-subtotal');
    const shippingLabelEl = document.querySelector('.cart-shipping-cost-l');
    const shippingCostEl = document.getElementById('cart-shipping-cost');
    const shippingValueEl = document.getElementById('cart-shipping-cost-value');
    const totalFinalEl = document.getElementById('cart-total-final');

    if (!subtotalEl || !totalFinalEl) return;

    const subtotal = Number(latestCartState && latestCartState.total_price ? latestCartState.total_price : 0);
    const freeShippingActive = hasFreeShipping(subtotal);
    const effectiveShippingCost = freeShippingActive ? 0 : currentShippingCost;
    const finalTotal = subtotal + effectiveShippingCost;

    if ((currentShippingCost > 0 || freeShippingActive) && shippingCostEl && shippingValueEl) {
      shippingCostEl.style.display = 'flex';
      if (shippingLabelEl) {
        shippingLabelEl.textContent = freeShippingActive
          ? 'Frete gratis'
          : (currentShippingMeta.deliveryText
            ? `${currentShippingMeta.serviceName} (${currentShippingMeta.deliveryText})`
            : currentShippingMeta.serviceName);
      }
      shippingValueEl.textContent = formatMoney(effectiveShippingCost);
    } else if (shippingCostEl) {
      shippingCostEl.style.display = 'none';
    }

    totalFinalEl.textContent = formatMoney(finalTotal);
    updateInstallmentDisplay(finalTotal);
  }

  // ─── GAMIFICAÇÃO FRETE GRÁTIS ───
  function updateFreeShippingBar(cartTotal) {
    // Ler valor dinâmico das configurações do tema (em centavos)
    const freeShippingThreshold = window.__ciaThemeSettings?.freeShippingThreshold || 25000;
    const bar = document.getElementById('free-shipping-bar');
    const message = document.getElementById('shipping-message');
    const progressFill = document.getElementById('progress-fill');
    
    if (!bar || !message || !progressFill) return;
    
    const amountRemaining = freeShippingThreshold - cartTotal;
    const progressPercent = Math.min((cartTotal / freeShippingThreshold) * 100, 100);
    
    // Mostrar barra se houver itens no carrinho
    if (cartTotal > 0) {
      bar.style.display = 'block';
      
      if (amountRemaining > 0) {
        // Ainda NÃO atingiu o frete grátis - manter AZUL
        bar.classList.remove('achieved');
        
        // Mensagem dinâmica baseada no progresso
        if (progressPercent < 50) {
          message.innerHTML = `Falta <strong>${formatMoney(amountRemaining)}</strong> para você ganhar <strong>FRETE GRÁTIS!</strong>`;
        } else {
          message.innerHTML = `Falta apenas <strong>${formatMoney(amountRemaining)}</strong> para <strong>FRETE GRÁTIS!</strong>`;
        }
      } else {
        // ATINGIU o frete grátis! 🎉 - Ficar VERDE
        bar.classList.add('achieved');
        message.innerHTML = `<strong>🎉 Parabéns! Você ganhou FRETE GRÁTIS!</strong>`;
      }
      
      // Atualizar barra de progresso
      progressFill.style.width = progressPercent + '%';
    } else {
      bar.style.display = 'none';
    }
  }

  async function renderCart() {
    const cart = await fetchCart();
    updateCartUI(cart);
  }

  window.updateQty = async function(key, qty) {
    // ⚡ ATUALIZAÇÃO INSTANTÂNEA - UI otimista (antes do fetch)
    const item = document.querySelector(`.cart-item[data-key="${key}"]`);
    if (!item) return;

    if (item.dataset.qtyUpdating === '1') return;
    item.dataset.qtyUpdating = '1';

    const targetQty = Math.max(0, Number.parseInt(qty, 10) || 0);
    
    const qtyDisplay = item.querySelector('.qty-v');
    const priceDisplay = item.querySelector('.cart-item-price');
    const buttons = item.querySelectorAll('.qty-b');
    
    // Salvar valores originais caso precise reverter
    const oldQty = qtyDisplay ? qtyDisplay.textContent : '';
    const oldPrice = priceDisplay ? priceDisplay.innerHTML : '';
    const oldQtyNumber = Number.parseInt(oldQty, 10) || 0;

    buttons.forEach((btn) => {
      btn.disabled = true;
      btn.style.pointerEvents = 'none';
    });
    
    // Atualizar UI IMEDIATAMENTE (antes do servidor responder)
    if (qtyDisplay) qtyDisplay.textContent = targetQty;
    
    // Se quantidade = 0, remover visualmente o item
    if (targetQty <= 0) {
      item.style.opacity = '0.5';
      item.style.pointerEvents = 'none';
    }
    
    // Atualizar os botões de quantidade
    buttons.forEach(btn => {
      const newQty = btn.getAttribute('aria-label').includes('Aumentar') ? targetQty + 1 : targetQty - 1;
      btn.dataset.qty = newQty;
    });
    
    try {
      // Fetch em background (não bloqueia a UI)
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: targetQty })
      });
      
      if (!response.ok) throw new Error('Erro ao atualizar');
      
      const cart = await response.json();
      // Re-render completo evita inconsistencias de key/data-qty na segunda alteracao.
      updateCartUI(cart);
      
    } catch (error) {
      // Reverter UI se deu erro
      if (qtyDisplay) qtyDisplay.textContent = oldQty;
      if (priceDisplay) priceDisplay.innerHTML = oldPrice;

      buttons.forEach((btn) => {
        const restoredQty = btn.getAttribute('aria-label').includes('Aumentar') ? oldQtyNumber + 1 : oldQtyNumber - 1;
        btn.dataset.qty = String(restoredQty);
      });

      item.style.opacity = '1';
      item.style.pointerEvents = 'auto';
      console.error('Erro ao atualizar quantidade:', error);
    } finally {
      if (item.isConnected) {
        buttons.forEach((btn) => {
          btn.disabled = false;
          btn.style.pointerEvents = '';
        });
      }
      item.dataset.qtyUpdating = '0';
    }
  };
  
  // Função otimizada para atualizar UI sem novo fetch
  function updateCartUI(cart) {
    const list = document.getElementById('cart-items-list');
    const sub = document.getElementById('cart-subtotal');
    const badge = document.querySelector('.cbadge');

    latestCartState = cart;
    
    if (!list) return;
    
    // Update badge
    if (badge) badge.textContent = cart.item_count;
    
    if (cart.item_count === 0) {
      list.innerHTML = '<p style="text-align:center;color:var(--gray);padding:40px 0;">Seu carrinho está vazio.</p>';
      if (sub) sub.textContent = 'R$ 0,00';
      const bar = document.getElementById('free-shipping-bar');
      if (bar) bar.style.display = 'none';
      updateCartSavingsSummary(cart);
      return;
    }
    
    list.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-key="${item.key}">
        <img class="cart-item-img"
          src="${item.image}"
          alt="${item.title}"
          width="72" height="90" loading="lazy">
        <div style="flex:1">
          <div class="cart-item-name">${item.product_title}</div>
          <div class="cart-item-meta-row">
            <div class="cart-item-meta">${getCartItemSize(item)}</div>
            <div class="cart-qty">
              <button class="qty-b" type="button" aria-label="Diminuir quantidade" data-qty="${item.quantity - 1}">−</button>
              <span class="qty-v">${item.quantity}</span>
              <button class="qty-b" type="button" aria-label="Aumentar quantidade" data-qty="${item.quantity + 1}">+</button>
            </div>
          </div>
        </div>
        <div class="cart-item-price">${getCartItemPriceHtml(item)}</div>
      </div>
    `).join('');
    
    if (sub) sub.textContent = formatMoney(cart.total_price);
    if (hasFreeShipping(cart.total_price) && currentShippingCost > 0) {
      setShippingFieldMessage('Frete gratis aplicado ao pedido.', 'success');
    } else {
      currentShippingCost = 0;
      currentShippingMeta = {
        serviceName: 'Frete',
        deliveryText: ''
      };
    }
    updateCartTotal();
    updateFreeShippingBar(cart.total_price);
    updateCartSavingsSummary(cart);
  }

  // ─── VARIANT SELECTOR ───
  function updateVariant() {
    const selected = {};
    document.querySelectorAll('.sz-btn.active, .col-btn.active').forEach(btn => {
      selected[btn.dataset.option] = btn.dataset.value;
    });

    // Recalcula disponibilidade de tamanhos considerando a cor ativa.
    updateSizeChipsByColor(selected);

    // Se o tamanho ativo ficou indisponivel para a cor selecionada, seleciona o primeiro disponivel.
    const activeSizeBtn = document.querySelector('.size-chip.active:not(:disabled), .sz-btn.active:not(:disabled)');
    if (!activeSizeBtn) {
      const firstAvailableSize = document.querySelector('.size-chip:not(:disabled), .sz-btn:not(:disabled)');
      if (firstAvailableSize) {
        document.querySelectorAll('.size-chip, .sz-btn').forEach((btn) => {
          btn.classList.remove('active');
          btn.classList.remove('size-chip--selected');
        });
        firstAvailableSize.classList.add('active');
        firstAvailableSize.classList.add('size-chip--selected');
        selected[firstAvailableSize.dataset.option] = firstAvailableSize.dataset.value;
      }
    }

    const variantData = window.__cia_variants_enriched || window.__cia_variants || [];
    const optionNames = window.__cia_option_names || [];
    const match = variantData.find((variant) =>
      variant.options.every((optionValue, index) => {
        const optionName = optionNames[index];
        if (!optionName) return true;
        if (!selected[optionName]) return true;
        return selected[optionName] === optionValue;
      })
    );

    if (match) {
      const idInput = document.getElementById('variant-id');
      if (idInput) idInput.value = match.id;
      const priceEl = document.querySelector('.pdp-price');
      if (priceEl && match.price) {
        priceEl.innerHTML = 'por ' + formatMoney(match.price) + ' <span class="lbl">à vista</span>';
      }

      const installmentEl = document.querySelector('.pdp-inst');
      if (installmentEl && match.price) {
        installmentEl.innerHTML = 'ou 5x <strong>' + formatMoney(Math.round(match.price / 5)) + ' sem juros</strong>';
      }

      const cashbackValueEl = document.querySelector('.pdp-cashback-value');
      if (cashbackValueEl && match.price) {
        cashbackValueEl.textContent = formatMoney(Math.round(match.price * 0.12));
      }

      const origPriceEl = document.querySelector('.pdp-orig');
      if (origPriceEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          origPriceEl.style.display = 'block';
          origPriceEl.textContent = 'de ' + formatMoney(match.compare_at_price);
        } else {
          origPriceEl.style.display = 'none';
        }
      }

      const skuWrap = document.getElementById('pdp-variant-sku');
      const skuValueEl = document.getElementById('pdp-variant-sku-value');
      if (skuWrap && skuValueEl) {
        const skuValue = String(match.sku || '').trim();
        skuValueEl.textContent = skuValue || '-';
        skuWrap.classList.toggle('is-empty', !skuValue);
      }

      const btn = document.getElementById('add-to-cart');
      if (btn) {
        btn.disabled = !match.available;
        btn.textContent = match.available ? 'adicionar ao carrinho' : 'indisponível';
      }
    }
    
    // Filtrar imagens por cor selecionada
    filterImagesByColor(selected);
  }

  function normalizeOptionValue(value) {
    return String(value || '').toLowerCase().trim().replace(/\s+/g, '');
  }

  function updateSizeChipsByColor(selected) {
    const chips = document.querySelectorAll('.size-chip');
    if (!chips.length) return;

    const variants = window.__cia_variants_enriched || window.__cia_variants || [];
    const optionNames = window.__cia_option_names || [];
    const selectorRoot = document.querySelector('.size-selector');
    const thresholdRaw = selectorRoot ? selectorRoot.dataset.lowStockThreshold : '10';
    const lowStockThreshold = parseInt(thresholdRaw || '10', 10) || 10;

    const activeColorBtn = document.querySelector('.col-btn.active');
    const colorOptionName = activeColorBtn ? activeColorBtn.dataset.option : '';
    const colorOptionValue = activeColorBtn ? activeColorBtn.dataset.value : '';
    const colorIndex = colorOptionName ? optionNames.indexOf(colorOptionName) : -1;

    chips.forEach((chip) => {
      const sizeOptionName = chip.dataset.option || '';
      const sizeValue = chip.dataset.value || '';
      const sizeIndex = optionNames.indexOf(sizeOptionName);
      if (sizeIndex === -1) return;

      const matchingVariants = variants.filter((variant) => {
        const sizeMatch = normalizeOptionValue(variant.options[sizeIndex]) === normalizeOptionValue(sizeValue);
        if (!sizeMatch) return false;

        if (colorIndex >= 0 && colorOptionValue) {
          return normalizeOptionValue(variant.options[colorIndex]) === normalizeOptionValue(colorOptionValue);
        }

        return true;
      });

      let inStock = false;
      let qty = 0;

      matchingVariants.forEach((variant) => {
        if (!variant.available) return;
        inStock = true;
        const inv = Number(variant.inventory_quantity) || 0;
        if (inv > 0) qty += inv;
      });

      const lowStock = inStock && qty > 0 && qty <= lowStockThreshold;
      const baseLabel = chip.dataset.size || sizeValue;

      chip.disabled = !inStock;
      chip.classList.toggle('size-chip--disabled', !inStock);
      chip.setAttribute('aria-disabled', inStock ? 'false' : 'true');
      chip.setAttribute('aria-label', inStock ? baseLabel : `${baseLabel} - Esgotado`);

      if (!inStock) {
        chip.classList.remove('active');
        chip.classList.remove('size-chip--selected');
      }

      const wrap = chip.closest('.chip-wrap');
      if (!wrap) return;

      wrap.classList.toggle('chip-wrap--low-stock', lowStock);
      let badge = wrap.querySelector('.stock-badge');

      if (lowStock) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'stock-badge';
          badge.setAttribute('aria-live', 'polite');
          wrap.appendChild(badge);
        }
        badge.textContent = qty === 1 ? 'resta 1' : `restam ${qty}`;
      } else if (badge) {
        badge.remove();
      }
    });
  }
  
  // Filtrar imagens baseado nas variantes selecionadas (cor, tamanho, etc)
  function filterImagesByColor(selected) {
    // Pegar TODAS as opções selecionadas
    const selectedOptions = {};
    Object.keys(selected).forEach(key => {
      if (selected[key]) {
        selectedOptions[key] = selected[key].toLowerCase().trim().replace(/\s+/g, '');
      }
    });
    
    // Se não há seleção, mostrar todas
    if (Object.keys(selectedOptions).length === 0) return;
    
    // Filtrar thumbs e imagens
    const thumbs = document.querySelectorAll('.thumb');
    const mainImages = document.querySelectorAll('.main-img');
    
    let firstVisibleThumb = null;
    let firstVisibleImage = null;
    
    thumbs.forEach((thumb) => {
      const thumbColor = thumb.dataset.color || '';
      const shouldShow = shouldShowImage(thumbColor, selectedOptions);

      if (shouldShow) {
        thumb.style.display = '';
        if (!firstVisibleThumb) firstVisibleThumb = thumb;
      } else {
        thumb.style.display = 'none';
        thumb.classList.remove('active');
      }
    });
    
    mainImages.forEach((img) => {
      const imgColor = img.dataset.color || '';
      const shouldShow = shouldShowImage(imgColor, selectedOptions);
      
      if (shouldShow) {
        img.style.display = '';
        if (!firstVisibleImage) firstVisibleImage = img;
      } else {
        img.style.display = 'none';
        img.classList.remove('active');
      }
    });
    
    // Ativar a primeira thumb e imagem visível
    if (firstVisibleThumb) {
      firstVisibleThumb.classList.add('active');
    }
    if (firstVisibleImage) {
      firstVisibleImage.classList.add('active');
    }

    // Re-sync slider state when visible images change (e.g. color selection).
    if (typeof window.__ciaRefreshPdpSlider === 'function') {
      window.__ciaRefreshPdpSlider();
    }
    
    // Atualizar label da cor selecionada
    updateColorLabel(selectedOptions);
  }
  
  // Atualizar o label mostrando a cor selecionada
  function updateColorLabel(selectedOptions) {
    const selectedColor = selectedOptions['Cor'] || selectedOptions['cor'] || selectedOptions['Color'] || '';
    
    // Buscar o label da cor (precisa encontrar o elemento com a cor)
    const colBtn = document.querySelector('.col-btn.active');
    if (colBtn && selectedColor) {
      const colorLabel = colBtn.getAttribute('title') || colBtn.getAttribute('aria-label') || selectedColor;
      const colorSelLabel = document.querySelector('.color-sel-label');
      if (colorSelLabel) {
        colorSelLabel.textContent = ': ' + colorLabel;
      }
    }
  }
  
  // Verificar se imagem deve ser mostrada baseado nas variantes
  function shouldShowImage(imageVariant, selectedOptions) {
    // Se imagem não tem variante específica (foto genérica), sempre mostrar
    if (!imageVariant || imageVariant === '') return true;
    
    const normalizedImageVariant = imageVariant.toLowerCase().trim().replace(/\s+/g, '');
    
    // Verificar se a cor da imagem bate EXATAMENTE com a cor selecionada
    const selectedColor = selectedOptions['Cor'] || selectedOptions['cor'] || selectedOptions['Color'] || '';
    
    if (selectedColor) {
      // Comparação EXATA (não substring)
      return normalizedImageVariant === selectedColor;
    }
    
    return true;
  }

  // ─── DELEGATED EVENTS ───
  document.addEventListener('click', (e) => {
    const searchToggleBtn = e.target.closest('#search-toggle');
    if (searchToggleBtn) {
      e.preventDefault();
      toggleSearchPanel();
      return;
    }

    const searchCloseBtn = e.target.closest('#search-close, #search-overlay');
    if (searchCloseBtn) {
      e.preventDefault();
      closeSearchPanel();
      return;
    }

    const cartOpenBtn = e.target.closest('#cart-toggle');
    if (cartOpenBtn) {
      e.preventDefault();
      openCart();
      return;
    }

    const cartCloseBtn = e.target.closest('#cart-close, #cart-overlay');
    if (cartCloseBtn) {
      e.preventDefault();
      closeCart();
      return;
    }

    const cartDrawerEl = e.target.closest('#cart-drawer');
    if (cartDrawerEl) {
      const drawerRect = cartDrawerEl.getBoundingClientRect();
      if (e.clientX < drawerRect.left) {
        e.preventDefault();
        closeCart();
        return;
      }
    }

    const continueShoppingBtn = e.target.closest('.continue-shopping');
    if (continueShoppingBtn) {
      e.preventDefault();
      closeCart();
      return;
    }

    const qtyBtn = e.target.closest('.qty-b');
    if (qtyBtn) {
      const item = qtyBtn.closest('.cart-item');
      const key = item && item.dataset ? item.dataset.key : '';
      const qty = parseInt(qtyBtn.dataset.qty || '', 10);
      if (key && !Number.isNaN(qty)) {
        window.updateQty(key, qty);
      }
      return;
    }

    const szBtn = e.target.closest('.sz-btn');
    if (szBtn) {
      const group = szBtn.closest('.sizes');
      if (group) group.querySelectorAll('.sz-btn').forEach((b) => b.classList.remove('active'));
      szBtn.classList.add('active');
      updateVariant();
      return;
    }

    const colBtn = e.target.closest('.col-btn');
    if (colBtn) {
      const group = colBtn.closest('.colors');
      if (group) group.querySelectorAll('.col-btn').forEach((b) => b.classList.remove('active'));
      colBtn.classList.add('active');
      updateVariant();
      return;
    }

    const thumb = e.target.closest('.thumb');
    if (thumb) {
      const thumbs = Array.from(document.querySelectorAll('.thumb'));
      const idx = thumbs.indexOf(thumb);
      thumbs.forEach((t) => t.classList.remove('active'));
      thumb.classList.add('active');
      const mainImgs = document.querySelectorAll('.main-img');
      mainImgs.forEach((m) => m.classList.remove('active'));
      if (mainImgs[idx]) mainImgs[idx].classList.add('active');
      return;
    }

    const menuBtn = e.target.closest('#mobile-menu-btn');
    if (menuBtn) {
      e.preventDefault();
      toggleMobileMenu();
      return;
    }

    const backBtn = e.target.closest('#mobile-back-btn');
    if (backBtn) {
      e.preventDefault();
      window.history.back();
      return;
    }

    const menuCloseBtn = e.target.closest('#mobile-menu-close, #mobile-menu-overlay');
    if (menuCloseBtn) {
      e.preventDefault();
      closeMobileMenu();
      return;
    }

    const submenuBtn = e.target.closest('[data-mobile-submenu-toggle]');
    if (submenuBtn) {
      const targetId = submenuBtn.getAttribute('aria-controls');
      const panel = targetId ? document.getElementById(targetId) : null;
      if (!panel) return;
      const expanded = submenuBtn.getAttribute('aria-expanded') === 'true';
      submenuBtn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      panel.hidden = expanded;
      return;
    }

    const mobileNavLink = e.target.closest('#mobile-menu a');
    if (mobileNavLink) {
      closeMobileMenu();
      return;
    }

    const filterBtn = e.target.closest('.fg-head');
    if (filterBtn) {
      const content = filterBtn.nextElementSibling;
      if (!content) return;
      const open = content.style.display !== 'none';
      content.style.display = open ? 'none' : '';
      filterBtn.setAttribute('aria-expanded', String(!open));
      const chevron = filterBtn.querySelector('svg');
      if (chevron) chevron.style.transform = open ? 'rotate(-90deg)' : '';
      return;
    }

    const chip = e.target.closest('.chip');
    if (chip) {
      chip.classList.toggle('active');
      return;
    }

  });

  document.addEventListener('submit', async (e) => {
    const couponForm = e.target.closest('#cart-coupon-form');
    if (couponForm) {
      e.preventDefault();

      const couponInput = document.getElementById('cart-coupon-input');
      const couponBtn = document.getElementById('cart-coupon-apply');
      const couponCode = couponInput ? couponInput.value.trim() : '';

      if (!couponInput || !couponBtn) return;

      if (!couponCode) {
        setCouponFieldMessage('Digite um cupom para aplicar.', 'error');
        couponInput.focus();
        return;
      }

      couponBtn.disabled = true;
      couponBtn.textContent = 'Aplicando...';
      setCouponFieldMessage('Aplicando cupom...', 'success');

      try {
        await applyCouponCode(couponCode);
        return;
      } catch (error) {
        setCouponFieldMessage(error.message || 'Erro ao aplicar cupom. Tente novamente.', 'error');
      } finally {
        couponBtn.disabled = false;
        couponBtn.textContent = 'Aplicar';
      }
      return;
    }

    const shippingForm = e.target.closest('#cart-shipping-form');
    if (shippingForm) {
      e.preventDefault();

      const cepInput = document.getElementById('cart-shipping-cep');
      const shippingBtn = document.getElementById('cart-shipping-apply');
      const shippingFeedback = document.getElementById('cart-shipping-feedback');
      const cep = cepInput ? cepInput.value.trim() : '';

      if (!cepInput || !shippingBtn || !shippingFeedback) return;

      if (!cep) {
        setShippingFieldMessage('Digite um CEP para calcular o frete.', 'error');
        cepInput.focus();
        return;
      }

      shippingBtn.disabled = true;
      shippingBtn.textContent = 'Calculando...';
      setShippingFieldMessage('Calculando frete...', 'success');

      try {
        const shippingResult = await calculateShipping(cep);
        updateCartTotal();

        const deliverySuffix = shippingResult.deliveryText ? ` • ${shippingResult.deliveryText}` : '';
        setShippingFieldMessage(
          `${shippingResult.serviceName}: ${formatMoney(shippingResult.priceCents)}${deliverySuffix}`,
          'success'
        );
      } catch (error) {
        console.error('[CART FRETE] Falha no cálculo de frete', {
          message: error && error.message ? error.message : 'Erro desconhecido',
          details: error && error.details ? error.details : null,
          latestDebug: window.__ciaShippingDebug || null
        });
        setShippingFieldMessage(error.message || 'Erro ao calcular frete. Tente novamente.', 'error');
      } finally {
        shippingBtn.disabled = false;
        shippingBtn.textContent = 'Calcular';
      }
      return;
    }

    const productForm = e.target.closest('#product-form');
    if (productForm) {
      e.preventDefault();
      const btn = document.getElementById('add-to-cart');
      const idInput = document.getElementById('variant-id');
      const id = idInput ? idInput.value : '';
      if (!btn || !id) return;

      btn.textContent = 'Adicionando...';
      btn.disabled = true;

      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 })
        });
        btn.textContent = '✓ Adicionado!';
        showToast('Produto adicionado ao carrinho!', 'success');
        setTimeout(() => openCart(), 400);
        setTimeout(() => {
          btn.textContent = 'adicionar ao carrinho';
          btn.disabled = false;
        }, 2000);
      } catch (err) {
        btn.textContent = 'Erro. Tente novamente.';
        btn.disabled = false;
      }
      return;
    }

    const newsletterForm = e.target.closest('.nl-form');
    if (newsletterForm) {
      // Let Shopify handle submit, only provide visual confirmation.
      setTimeout(() => showToast('✅ Cadastro realizado com sucesso!', 'success'), 300);
    }
  });

  document.addEventListener('change', (e) => {
    const sortSel = e.target.closest('.sort-sel');
    if (!sortSel) return;
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortSel.value);
    window.location.href = url.toString();
  });

  document.addEventListener('focusin', (e) => {
    const shippingInput = e.target.closest('#cart-shipping-cep');
    if (!shippingInput) return;
    resetShippingFieldState();
  });

  document.addEventListener('input', (e) => {
    const shippingInput = e.target.closest('#cart-shipping-cep');
    if (!shippingInput) return;
    shippingInput.classList.remove('is-success');
    shippingInput.classList.remove('is-error');

    const couponInput = e.target.closest('#cart-coupon-input');
    if (!couponInput) return;
    couponInput.classList.remove('is-success');
    couponInput.classList.remove('is-error');
  });

  document.addEventListener('focusin', (e) => {
    const couponInput = e.target.closest('#cart-coupon-input');
    if (!couponInput) return;
    resetCouponFieldState();
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth > 768) closeMobileMenu();
  }, { passive: true });

  // ─── HEADER SCROLL ───
  const header = document.querySelector('.header');
  if (header) {
    let ticking = false;
    let hasShadow = false;

    const updateHeaderShadow = () => {
      const shouldHaveShadow = window.scrollY > 10;
      if (shouldHaveShadow !== hasShadow) {
        header.style.boxShadow = shouldHaveShadow ? '0 4px 20px rgba(0,0,0,.12)' : '';
        hasShadow = shouldHaveShadow;
      }
      ticking = false;
    };

    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateHeaderShadow);
    }, { passive: true });

    updateHeaderShadow();
  }

  // ─── WISHLIST (localStorage) ───
  window.toggleWishlist = function(btn) {
    const pid = btn.dataset.product || btn.dataset.wishlistProduct;
    const saved = JSON.parse(localStorage.getItem('cia_wishlist') || '[]');
    const idx = saved.indexOf(pid);
    if (idx === -1) {
      saved.push(pid);
      btn.classList.add('active');
      showToast('❤️ Adicionado aos favoritos!', 'success');
    } else {
      saved.splice(idx, 1);
      btn.classList.remove('active');
      showToast('Removido dos favoritos');
    }
    localStorage.setItem('cia_wishlist', JSON.stringify(saved));
  };

  function applyWishlistState(root) {
    const ctx = root || document;
    const wishlist = JSON.parse(localStorage.getItem('cia_wishlist') || '[]');
    ctx.querySelectorAll('[data-wishlist-product],[data-product]').forEach((btn) => {
      const pid = btn.dataset.product || btn.dataset.wishlistProduct;
      if (wishlist.includes(pid)) btn.classList.add('active');
      else btn.classList.remove('active');
    });
  }

  // Non-critical hydration is deferred to reduce startup blocking.
  runWhenIdle(() => {
    applyWishlistState(document);
  });

  if (sessionStorage.getItem('ciaOpenCartAfterDiscount') === '1') {
    sessionStorage.removeItem('ciaOpenCartAfterDiscount');
    window.setTimeout(() => {
      openCart();
    }, 150);
  }

  // Schedule initial PDP variant sync after first paint.
  if (document.getElementById('product-form')) {
    window.setTimeout(updateVariant, 0);
  }

  // ─── BANNER CAROUSEL ───
  function initPdpImageSlider() {
    const sliders = document.querySelectorAll('[data-pdp-slider]');
    if (!sliders.length) return;

    const getVisibleSlides = (track) =>
      Array.from(track.querySelectorAll('.main-img')).filter((slide) => slide.style.display !== 'none');

    sliders.forEach((slider) => {
      if (slider.dataset.sliderReady === 'true') return;

      const track = slider.querySelector('[data-pdp-track]');
      const dotsWrap = slider.querySelector('[data-pdp-dots]');
      const prevBtn = slider.querySelector('[data-pdp-prev]');
      const nextBtn = slider.querySelector('[data-pdp-next]');

      if (!track || !dotsWrap) return;

      const getCurrentVisibleIndex = (visibleSlides) => {
        if (!visibleSlides.length) return 0;
        const currentScroll = track.scrollLeft;
        let nearestIndex = 0;
        let nearestDistance = Number.POSITIVE_INFINITY;

        visibleSlides.forEach((slide, index) => {
          const distance = Math.abs(slide.offsetLeft - currentScroll);
          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestIndex = index;
          }
        });

        return nearestIndex;
      };

      const scrollToVisibleIndex = (index) => {
        const visibleSlides = getVisibleSlides(track);
        if (!visibleSlides.length) return;
        const safeIndex = Math.max(0, Math.min(index, visibleSlides.length - 1));
        track.scrollTo({ left: visibleSlides[safeIndex].offsetLeft, behavior: 'smooth' });
      };

      const renderDots = () => {
        const visibleSlides = getVisibleSlides(track);
        dotsWrap.innerHTML = '';

        visibleSlides.forEach((_, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'pdp-slider-dot';
          dot.setAttribute('data-pdp-dot-index', String(index));
          dot.setAttribute('aria-label', `Ir para imagem ${index + 1}`);
          dotsWrap.appendChild(dot);
        });

        if (prevBtn) prevBtn.style.display = visibleSlides.length > 1 ? '' : 'none';
        if (nextBtn) nextBtn.style.display = visibleSlides.length > 1 ? '' : 'none';
      };

      const updateDots = () => {
        const visibleSlides = getVisibleSlides(track);
        const activeIndex = getCurrentVisibleIndex(visibleSlides);
        dotsWrap.querySelectorAll('.pdp-slider-dot').forEach((dot, index) => {
          dot.classList.toggle('is-active', index === activeIndex);
        });
      };

      const refresh = () => {
        renderDots();
        const visibleSlides = getVisibleSlides(track);
        if (!visibleSlides.length) return;

        const activeSlide = visibleSlides.find((slide) => slide.classList.contains('active')) || visibleSlides[0];
        track.scrollTo({ left: activeSlide.offsetLeft, behavior: 'auto' });
        updateDots();
      };

      dotsWrap.addEventListener('click', (event) => {
        const dot = event.target.closest('[data-pdp-dot-index]');
        if (!dot) return;
        const index = parseInt(dot.dataset.pdpDotIndex || '0', 10);
        if (Number.isNaN(index)) return;
        scrollToVisibleIndex(index);
      });

      track.addEventListener('scroll', () => {
        if (track._pdpScrollFrame) window.cancelAnimationFrame(track._pdpScrollFrame);
        track._pdpScrollFrame = window.requestAnimationFrame(updateDots);
      }, { passive: true });

      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          const visibleSlides = getVisibleSlides(track);
          const current = getCurrentVisibleIndex(visibleSlides);
          scrollToVisibleIndex(current - 1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          const visibleSlides = getVisibleSlides(track);
          const current = getCurrentVisibleIndex(visibleSlides);
          scrollToVisibleIndex(current + 1);
        });
      }

      slider.__pdpRefresh = refresh;
      slider.dataset.sliderReady = 'true';
      refresh();
    });

    window.__ciaRefreshPdpSlider = () => {
      document.querySelectorAll('[data-pdp-slider]').forEach((slider) => {
        if (typeof slider.__pdpRefresh === 'function') slider.__pdpRefresh();
      });
    };
  }

  function initBannerCarousel() {
    const carousels = document.querySelectorAll('[data-carousel]');
    if (!carousels.length) return;

    carousels.forEach(carousel => {
      if (carousel.dataset.carouselReady === 'true') return;

      const carouselId = carousel.dataset.carousel;
      const track = carousel.querySelector(`[data-carousel-track="${carouselId}"]`);
      const prevBtn = carousel.querySelector(`[data-carousel-prev="${carouselId}"]`);
      const nextBtn = carousel.querySelector(`[data-carousel-next="${carouselId}"]`);
      const dots = carousel.querySelectorAll(`[data-carousel-dot]`);

      if (!track || !prevBtn || !nextBtn || !dots.length) return;

      const slides = track.querySelectorAll('.carousel-slide');
      if (!slides.length) return;

      let currentIndex = 0;
      let autoplayInterval = null;
      let touchStartX = 0;
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const autoplaySpeed = (carousel.querySelector('[data-autoplay-speed]')?.dataset?.autoplaySpeed || 5) * 1000;

      function goToSlide(index) {
        // Wrap around
        currentIndex = (index + slides.length) % slides.length;
        const offset = -currentIndex * 100;
        track.style.transform = `translateX(${offset}%)`;

        // Update dots
        dots.forEach((dot, i) => {
          const isActive = i === currentIndex;
          dot.classList.toggle('active', isActive);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      }

      function nextSlide() {
        goToSlide(currentIndex + 1);
      }

      function prevSlide() {
        goToSlide(currentIndex - 1);
      }

      function startAutoplay() {
        if (prefersReducedMotion) return;
        stopAutoplay();
        autoplayInterval = setInterval(nextSlide, autoplaySpeed);
      }

      function stopAutoplay() {
        if (autoplayInterval) {
          clearInterval(autoplayInterval);
          autoplayInterval = null;
        }
      }

      // Navigation buttons
      if (prevBtn) prevBtn.addEventListener('click', () => {
        goToSlide(currentIndex - 1);
        stopAutoplay();
        startAutoplay();
      });

      if (nextBtn) nextBtn.addEventListener('click', () => {
        goToSlide(currentIndex + 1);
        stopAutoplay();
        startAutoplay();
      });

      // Dots
      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const index = parseInt(dot.dataset.carouselDot, 10);
          goToSlide(index);
          stopAutoplay();
          startAutoplay();
        });
      });

      // Touch/swipe
      track.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
        stopAutoplay();
      }, { passive: true });

      track.addEventListener('touchend', (e) => {
        const touchEndX = e.changedTouches[0].screenX;
        const delta = touchStartX - touchEndX;
        
        if (Math.abs(delta) > 50) {
          if (delta > 0) nextSlide();
          else prevSlide();
        }
        startAutoplay();
      }, { passive: true });

      // Pause on hover
      carousel.addEventListener('mouseenter', stopAutoplay);
      carousel.addEventListener('mouseleave', startAutoplay);

      // Start autoplay
      startAutoplay();

      // Cleanup on section unload
      carousel._carouselCleanup = () => stopAutoplay();
      carousel.dataset.carouselReady = 'true';
    });
  }

  // Initialize on load (defer carousels until they are near viewport)
  runWhenIdle(() => {
    initPdpImageSlider();
    document.querySelectorAll('[data-carousel]').forEach((carousel) => {
      runWhenVisible(carousel, () => {
        initBannerCarousel();
      });
    });
  });

  // ─── VIDEO PLAYER ───
  function resetVideoWrap(videoWrap) {
    if (!videoWrap) return;

    // External embeds/videos rendered dynamically.
    if (videoWrap.dataset.originalContent) {
      videoWrap.innerHTML = videoWrap.dataset.originalContent;
      delete videoWrap.dataset.originalContent;
      return;
    }

    // Shopify native video block.
    const videoPlayer = videoWrap.querySelector('.video-player');
    const video = videoPlayer ? videoPlayer.querySelector('video') : null;
    const cover = videoWrap.querySelector('.video-cover');
    const overlay = videoWrap.querySelector('.v-overlay');
    const content = videoWrap.querySelector('.v-content');

    if (video) {
      video.pause();
      video.currentTime = 0;
      video.controls = false;
    }
    if (videoPlayer) videoPlayer.style.display = 'none';
    if (cover) cover.style.display = 'block';
    if (overlay) overlay.style.display = 'block';
    if (content) content.style.display = 'block';
  }

  function resetAllVideos() {
    document.querySelectorAll('.video-wrap').forEach(resetVideoWrap);
  }

  document.addEventListener('click', (e) => {
    const playBtn = e.target.closest('.play-btn');
    if (!playBtn) return;
    
    const videoWrap = playBtn.closest('.video-wrap');
    if (!videoWrap) return;
    
    const videoType = videoWrap.dataset.videoType;
    const videoUrl = videoWrap.dataset.video;
    const videoPlayer = videoWrap.querySelector('.video-player');
    
    // Se for vídeo da Shopify
    if (videoType === 'shopify' && videoPlayer) {
      const cover = videoWrap.querySelector('.video-cover');
      const overlay = videoWrap.querySelector('.v-overlay');
      const content = videoWrap.querySelector('.v-content');
      
      // Esconder capa e botão
      if (cover) cover.style.display = 'none';
      if (overlay) overlay.style.display = 'none';
      if (content) content.style.display = 'none';
      
      // Mostrar e reproduzir vídeo
      videoPlayer.style.display = 'block';
      const video = videoPlayer.querySelector('video');
      if (video) {
        video.play();
        video.controls = true;
        
        // Quando o vídeo terminar ou for pausado, voltar ao estado inicial
        const resetVideo = () => {
          if (video.paused && video.currentTime > 0) {
            setTimeout(() => {
              if (video.paused) {
                videoPlayer.style.display = 'none';
                if (cover) cover.style.display = 'block';
                if (overlay) overlay.style.display = 'block';
                if (content) content.style.display = 'block';
                video.currentTime = 0;
              }
            }, 2000); // Espera 2s para ver se realmente pausou
          }
        };
        
        video.addEventListener('ended', () => {
          videoPlayer.style.display = 'none';
          if (cover) cover.style.display = 'block';
          if (overlay) overlay.style.display = 'block';
          if (content) content.style.display = 'block';
          video.currentTime = 0;
        });
        
        video.addEventListener('pause', resetVideo);
      }
    }
    // Se for URL externa (YouTube/Vimeo/MP4)
    else if (videoUrl) {
      // Salvar conteúdo original se ainda não foi salvo
      if (!videoWrap.dataset.originalContent) {
        videoWrap.dataset.originalContent = videoWrap.innerHTML;
      }
      
      let embedUrl = videoUrl;
      const isDirectVideoFile = /\.(mp4|webm|ogg)(\?|#|$)/i.test(videoUrl);
      
      // Converter URLs do YouTube para embed com autoplay
      if (videoUrl.includes('youtube.com') || videoUrl.includes('youtu.be')) {
        const videoId = videoUrl.includes('youtu.be') 
          ? videoUrl.split('youtu.be/')[1]?.split('?')[0]
          : new URL(videoUrl).searchParams.get('v');
        if (videoId) embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
      }
      // Converter URLs do Vimeo para embed com autoplay
      else if (videoUrl.includes('vimeo.com')) {
        const videoId = videoUrl.split('vimeo.com/')[1]?.split('?')[0];
        if (videoId) embedUrl = `https://player.vimeo.com/video/${videoId}?autoplay=1`;
      }
      
      // MP4/WebM/Ogg: usar tag <video> para evitar comportamento inconsistente de iframe.
      if (isDirectVideoFile) {
        const extension = (videoUrl.split('.').pop() || 'mp4').split(/[?#]/)[0].toLowerCase();
        videoWrap.innerHTML = `
          <video
            class="shopify-video"
            autoplay
            controls
            playsinline
            preload="metadata"
            style="position:absolute;top:0;left:0;width:100%;height:100%;"
          >
            <source src="${videoUrl}" type="video/${extension}">
          </video>
          <button class="video-close-btn" aria-label="Fechar vídeo" style="position:absolute;top:16px;right:16px;z-index:10;width:40px;height:40px;border-radius:50%;background:rgba(0,0,0,0.7);color:#fff;border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:background 0.2s;">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        `;
      } else {
        // Criar iframe com botão de fechar (YouTube/Vimeo)
        videoWrap.innerHTML = `
          <iframe
            src="${embedUrl}"
            frameborder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowfullscreen
            style="position:absolute;top:0;left:0;width:100%;height:100%;"
          ></iframe>
          <button class="video-close-btn" aria-label="Fechar vídeo" style="position:absolute;top:16px;right:16px;z-index:10;width:40px;height:40px;border-radius:50%;background:rgba(0,0,0,0.7);color:#fff;border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:background 0.2s;">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        `;
      }
    }
  });
  
  // Fechar vídeo externo e restaurar estado original
  document.addEventListener('click', (e) => {
    const closeBtn = e.target.closest('.video-close-btn');
    if (!closeBtn) return;
    
    const videoWrap = closeBtn.closest('.video-wrap');
    if (!videoWrap) return;
    resetVideoWrap(videoWrap);
  });

  // Evita áudio tocando no fundo ao navegar/voltar para a home (bfcache incluso).
  window.addEventListener('pagehide', resetAllVideos);
  window.addEventListener('beforeunload', resetAllVideos);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) resetAllVideos();
  });

  // ─── SIZE TABLE MODAL ───
  function openSizeTableModal(imageUrl) {
    const overlay = document.getElementById('size-table-modal-overlay');
    const image = document.getElementById('size-table-image');
    if (!overlay || !image) return;
    if (!imageUrl) {
      showToast('Tabela de medidas não disponível para este produto', 'error');
      return;
    }
    // Garantir protocolo HTTPS se a URL começar com //
    const fullUrl = imageUrl.startsWith('//') ? 'https:' + imageUrl : imageUrl;
    image.src = fullUrl;
    overlay.classList.add('open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeSizeTableModal() {
    const overlay = document.getElementById('size-table-modal-overlay');
    if (!overlay) return;
    overlay.classList.remove('open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  // Event listeners for size table modal
  document.addEventListener('click', (e) => {
    const sizeTableBtn = e.target.closest('#size-table-btn');
    if (sizeTableBtn) {
      e.preventDefault();
      const imageUrl = sizeTableBtn.dataset.image;
      openSizeTableModal(imageUrl);
      return;
    }

    const modalClose = e.target.closest('#modal-close-btn');
    if (modalClose) {
      e.preventDefault();
      closeSizeTableModal();
      return;
    }

    const modalOverlay = e.target.closest('#size-table-modal-overlay');
    if (modalOverlay && e.target === modalOverlay) {
      e.preventDefault();
      closeSizeTableModal();
      return;
    }
  });

  // Close modal on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const overlay = document.getElementById('size-table-modal-overlay');
      if (overlay && overlay.classList.contains('open')) {
        closeSizeTableModal();
      }
    }
  });

  // ─── TOAST ───
  function showToast(msg, type = '') {
    let t = document.querySelector('.toast-msg');
    if (!t) {
      t = document.createElement('div');
      t.className = 'toast-msg';
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.className = 'toast-msg show' + (type ? ' ' + type : '');
    clearTimeout(window.__toastTimer);
    window.__toastTimer = setTimeout(() => { t.className = 'toast-msg'; }, 2800);
  }

  // ─── BENEFITS CAROUSEL ───
  function initBenefitsCarousel() {
    const carousel = document.querySelector('[data-benefits-carousel]');
    if (!carousel) return;

    const track = carousel.querySelector('[data-benefits-track]');
    const dots = carousel.querySelectorAll('[data-carousel-dot]');
    const slides = carousel.querySelectorAll('[data-benefit-slide]');
    
    if (!track || slides.length === 0) return;

    let currentIndex = 0;
    let autoplayInterval = null;
    let touchStartX = 0;
    let touchEndX = 0;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    
    // Get autoplay speed from section settings (default 3s)
    const sectionElement = carousel.closest('.shopify-section');
    const autoplaySpeed = (sectionElement?.dataset?.autoplaySpeed || 3) * 1000;

    // Only activate carousel on mobile (≤768px)
    function isMobile() {
      return window.innerWidth <= 768;
    }

    function goToSlide(index) {
      if (!isMobile()) return;
      currentIndex = index;
      const offset = -currentIndex * 100;
      track.style.transform = `translateX(${offset}%)`;
      
      // Update dots
      dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === currentIndex);
      });
    }

    function nextSlide() {
      if (!isMobile()) return;
      const nextIndex = (currentIndex + 1) % slides.length;
      goToSlide(nextIndex);
    }

    function prevSlide() {
      if (!isMobile()) return;
      const prevIndex = (currentIndex - 1 + slides.length) % slides.length;
      goToSlide(prevIndex);
    }

    function startAutoplay() {
      if (!isMobile() || prefersReducedMotion) return;
      stopAutoplay();
      autoplayInterval = setInterval(nextSlide, autoplaySpeed);
    }

    function stopAutoplay() {
      if (autoplayInterval) {
        clearInterval(autoplayInterval);
        autoplayInterval = null;
      }
    }

    function resetDesktop() {
      if (!isMobile()) {
        track.style.transform = '';
        stopAutoplay();
      }
    }

    // Dots navigation
    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        if (!isMobile()) return;
        const index = parseInt(dot.dataset.carouselDot, 10);
        goToSlide(index);
        stopAutoplay();
        startAutoplay();
      });
    });

    // Touch/swipe support
    track.addEventListener('touchstart', (e) => {
      if (!isMobile()) return;
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    track.addEventListener('touchend', (e) => {
      if (!isMobile()) return;
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    }, { passive: true });

    function handleSwipe() {
      const swipeThreshold = 50;
      const diff = touchStartX - touchEndX;
      
      if (Math.abs(diff) < swipeThreshold) return;
      
      stopAutoplay();
      if (diff > 0) {
        nextSlide(); // Swipe left
      } else {
        prevSlide(); // Swipe right
      }
      startAutoplay();
    }

    // Pause on hover (mobile only)
    carousel.addEventListener('mouseenter', () => {
      if (isMobile()) stopAutoplay();
    });
    carousel.addEventListener('mouseleave', () => {
      if (isMobile()) startAutoplay();
    });

    // Handle resize
    window.addEventListener('resize', () => {
      resetDesktop();
      if (isMobile() && slides.length > 1 && !prefersReducedMotion) {
        startAutoplay();
      }
    }, { passive: true });

    // Start autoplay if mobile and more than 1 slide
    if (isMobile() && slides.length > 1 && !prefersReducedMotion) {
      startAutoplay();
    }

    // Cleanup on section unload
    return () => {
      stopAutoplay();
    };
  }

  // Initialize carousel
  runWhenIdle(() => {
    initBenefitsCarousel();
  });

  // ─── BRAND STATS COUNT-UP ANIMATION ───
  function animateCountUp(el, target, duration = 2000) {
    const start = performance.now();
    const startVal = 0;

    function update(now) {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      // Easing: easeOutExpo - desacelera no final como odômetro
      const ease = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
      const currentValue = Math.floor(ease * (target - startVal) + startVal);
      el.textContent = currentValue.toLocaleString('pt-BR');
      if (progress < 1) requestAnimationFrame(update);
    }

    requestAnimationFrame(update);
  }

  function initStatsAnimation() {
    const statItems = document.querySelectorAll('[data-stat-item]');
    if (statItems.length === 0) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target.querySelector('.stat-number');
          if (!el) return;
          
          const target = parseInt(el.dataset.target, 10);
          if (isNaN(target)) return;
          
          // Ajustar duração baseado no tamanho do número
          const duration = target > 1000 ? 2000 : target > 100 ? 1500 : 1200;
          
          // Pequeno delay para criar efeito escalonado se múltiplos entrarem juntos
          const index = Array.from(statItems).indexOf(entry.target);
          setTimeout(() => {
            animateCountUp(el, target, duration);
          }, index * 100);
          
          observer.unobserve(entry.target);
        }
      });
    }, { 
      threshold: 0.3,
      rootMargin: '0px 0px -50px 0px' 
    });

    statItems.forEach(item => observer.observe(item));
  }

  // Initialize stats animation
  runWhenIdle(() => {
    initStatsAnimation();
  });

  // ─── FLOATING BACK TO TOP ───
  function initBackToTopButton() {
    const backToTopBtn = document.querySelector('[data-scroll-top]');
    if (!backToTopBtn) return;

    if (backToTopBtn.dataset.initialized === 'true') {
      return;
    }
    backToTopBtn.dataset.initialized = 'true';

    const toggleVisibility = () => {
      const shouldShow = window.scrollY > 360;
      backToTopBtn.classList.toggle('is-visible', shouldShow);
    };

    toggleVisibility();
    window.addEventListener('scroll', toggleVisibility, { passive: true });

    backToTopBtn.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  runWhenIdle(() => {
    initBackToTopButton();
  });

  document.addEventListener('shopify:section:load', () => {
    initBackToTopButton();
  });

  // ─── COUPON COPY TO CLIPBOARD ───
  document.addEventListener('click', (e) => {
    const copyBtn = e.target.closest('[data-coupon-copy]');
    if (!copyBtn) return;
    
    e.preventDefault();
    
    const banner = copyBtn.closest('[data-coupon-banner]');
    if (!banner) return;
    
    const code = copyBtn.dataset.code;
    if (!code) return;
    
    // Copy to clipboard
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code)
        .then(() => {
          // Show success state
          copyBtn.classList.add('copied');
          showToast('✓ Cupom copiado: ' + code, 'success');
          
          // Revert after 2 seconds
          setTimeout(() => {
            copyBtn.classList.remove('copied');
          }, 2000);
        })
        .catch((err) => {
          console.error('Erro ao copiar:', err);
          showToast('Erro ao copiar cupom', 'error');
        });
    } else {
      // Fallback for browsers without clipboard API
      const textarea = document.createElement('textarea');
      textarea.value = code;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      
      try {
        document.execCommand('copy');
        copyBtn.classList.add('copied');
        showToast('✓ Cupom copiado: ' + code, 'success');
        
        setTimeout(() => {
          copyBtn.classList.remove('copied');
        }, 2000);
      } catch (err) {
        console.error('Erro ao copiar:', err);
        showToast('Erro ao copiar cupom', 'error');
      }
      
      document.body.removeChild(textarea);
    }
  });

  // ─── PRODUCT SLIDER ───
  function initProductSliders() {
    const sliders = document.querySelectorAll('[data-product-slider]');
    if (!sliders.length) return;

    sliders.forEach(slider => {
      if (slider.dataset.sliderReady === 'true') return;

      const sliderId = slider.dataset.productSlider;
      const track = slider.querySelector(`[data-slider-track="${sliderId}"]`);
      const prevBtn = slider.querySelector(`[data-slider-prev="${sliderId}"]`);
      const nextBtn = slider.querySelector(`[data-slider-next="${sliderId}"]`);
      
      if (!track || !prevBtn || !nextBtn) return;

      const cards = track.querySelectorAll('.slider-card');
      if (!cards.length) return;

      function getCards() {
        return Array.from(track.querySelectorAll('.slider-card')).filter((card) => card && card.isConnected);
      }

      function getCardStepWidth() {
        const currentCards = getCards();
        if (!currentCards.length) return track.clientWidth;

        if (currentCards.length === 1) {
          return currentCards[0].getBoundingClientRect().width;
        }

        return Math.abs(currentCards[1].offsetLeft - currentCards[0].offsetLeft) || currentCards[0].getBoundingClientRect().width;
      }

      function getVisibleCardsPerView() {
        if (window.innerWidth >= 1025) return 4;
        if (window.innerWidth >= 769) return 3;
        return 1;
      }

      function getCardsPerArrowStep() {
        return getVisibleCardsPerView();
      }

      function getNearestCardIndex(targetScrollLeft = track.scrollLeft) {
        const currentCards = getCards();
        if (!currentCards.length) return 0;

        let nearestIndex = 0;
        let nearestDistance = Number.POSITIVE_INFINITY;

        currentCards.forEach((card, index) => {
          const distance = Math.abs(card.offsetLeft - targetScrollLeft);
          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestIndex = index;
          }
        });

        return nearestIndex;
      }

      function scrollToCardIndex(index, behavior = 'smooth') {
        const currentCards = getCards();
        if (!currentCards.length) return;

        const maxIndex = Math.max(0, currentCards.length - getVisibleCardsPerView());
        const safeIndex = Math.max(0, Math.min(index, maxIndex));
        track.scrollTo({ left: currentCards[safeIndex].offsetLeft, behavior });
      }

      // Update arrow states based on scroll position
      function updateArrows() {
        const scrollLeft = track.scrollLeft;
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        const epsilon = 4;
        const currentCards = getCards();

        if (currentCards.length <= getVisibleCardsPerView()) {
          prevBtn.disabled = true;
          nextBtn.disabled = true;
          return;
        }
        
        // Hide left arrow at start
        prevBtn.disabled = scrollLeft <= epsilon;
        
        // Hide right arrow at end
        nextBtn.disabled = scrollLeft >= maxScroll - epsilon;
      }

      // Scroll to next card
      function scrollNext() {
        const step = getCardsPerArrowStep();
        scrollToCardIndex(getNearestCardIndex() + step, 'smooth');
      }

      // Scroll to previous card
      function scrollPrev() {
        const step = getCardsPerArrowStep();
        scrollToCardIndex(getNearestCardIndex() - step, 'smooth');
      }

      const MOBILE_SWIPE_SPEED = 'medium';
      const MOBILE_SWIPE_CONFIG = {
        slow: { threshold: 0.56, resistance: 1.6, maxSteps: 3, lazyDelay: 150 },
        medium: { threshold: 0.40, resistance: 1.25, maxSteps: 5, lazyDelay: 120 },
        fast: { threshold: 0.26, resistance: 1.0, maxSteps: 6, lazyDelay: 90 }
      };

      function getMobileSwipeConfig() {
        return MOBILE_SWIPE_CONFIG[MOBILE_SWIPE_SPEED] || MOBILE_SWIPE_CONFIG.medium;
      }

      let touchStartX = 0;
      let touchStartY = 0;
      let touchStartScrollLeft = 0;
      let isTouchSwiping = false;
      let lazySnapTimer = null;

      function handleTouchSwipeStart(clientX, clientY) {
        touchStartX = clientX;
        touchStartY = clientY;
        touchStartScrollLeft = track.scrollLeft;
        track.__touchStartTime = Date.now();
        isTouchSwiping = true;
        track.style.scrollSnapType = 'none';
      }

      function handleTouchSwipeMove(clientX, clientY) {
        if (!isTouchSwiping) return;

        const cfg = getMobileSwipeConfig();
        const deltaX = (touchStartX - clientX) * cfg.resistance;
        const deltaY = Math.abs(touchStartY - clientY);

        if (Math.abs(deltaX) <= deltaY) {
          return;
        }

        track.scrollLeft = touchStartScrollLeft + deltaX;
      }

      function handleTouchSwipeEnd(clientX, clientY) {
        if (!isTouchSwiping) return;
        isTouchSwiping = false;
        track.style.scrollSnapType = 'x mandatory';

        const deltaX = touchStartX - clientX;
        const deltaY = Math.abs(touchStartY - clientY);
        const absDeltaX = Math.abs(deltaX);

        if (absDeltaX <= deltaY || absDeltaX < 8) {
          scrollToCardIndex(getNearestCardIndex(touchStartScrollLeft), 'smooth');
          return;
        }

        const cfg = getMobileSwipeConfig();
        const stepWidth = Math.max(1, getCardStepWidth());
        const baseIndex = getNearestCardIndex(touchStartScrollLeft);
        const direction = deltaX > 0 ? 1 : -1;
        const thresholdPx = stepWidth * cfg.threshold;
        const currentTravelPx = Math.abs(track.scrollLeft - touchStartScrollLeft);
        const travelRatio = currentTravelPx / stepWidth;

        let swipeSteps = 1;
        if (travelRatio >= 2.2) swipeSteps = 3;
        else if (travelRatio >= 1.2) swipeSteps = 2;

        // Quick swipe can gain one extra card, but still bounded.
        const elapsed = Math.max(1, Date.now() - (track.__touchStartTime || Date.now()));
        const velocity = absDeltaX / elapsed;
        if (velocity >= 1.0 && swipeSteps < (cfg.maxSteps || 5)) {
          swipeSteps += 1;
        }

        swipeSteps = Math.max(1, Math.min(cfg.maxSteps || 5, swipeSteps));

        if (deltaX > thresholdPx || deltaX < -thresholdPx) {
          scrollToCardIndex(baseIndex + (direction * swipeSteps), 'smooth');
        } else {
          scrollToCardIndex(baseIndex, 'smooth');
        }
      }

      // Event listeners
      nextBtn.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        scrollNext();
      });
      prevBtn.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        scrollPrev();
      });
      [prevBtn, nextBtn].forEach((button) => {
        button.addEventListener('pointerdown', (event) => {
          event.stopPropagation();
        });
        button.addEventListener('touchstart', (event) => {
          event.stopPropagation();
        }, { passive: true });
      });

      if (window.PointerEvent) {
        track.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'pen') return;
          handleTouchSwipeStart(event.clientX, event.clientY);
        });

        track.addEventListener('pointermove', (event) => {
          if (event.pointerType !== 'pen') return;
          handleTouchSwipeMove(event.clientX, event.clientY);
        });

        const endPointerSwipe = (event) => {
          if (event.pointerType !== 'pen') return;
          handleTouchSwipeEnd(event.clientX, event.clientY);
        };

        track.addEventListener('pointerup', endPointerSwipe);
        track.addEventListener('pointercancel', endPointerSwipe);
      }

      track.addEventListener('touchstart', (event) => {
        const touch = event.changedTouches[0];
        if (!touch) return;
        handleTouchSwipeStart(touch.clientX, touch.clientY);
      }, { passive: true });

      track.addEventListener('touchmove', (event) => {
        const touch = event.changedTouches[0];
        if (!touch) return;
        handleTouchSwipeMove(touch.clientX, touch.clientY);
      }, { passive: true });

      track.addEventListener('touchend', (event) => {
        const touch = event.changedTouches[0];
        if (!touch) return;
        handleTouchSwipeEnd(touch.clientX, touch.clientY);
      }, { passive: true });

      track.addEventListener('touchcancel', () => {
        isTouchSwiping = false;
        track.style.scrollSnapType = 'x mandatory';
      }, { passive: true });

      track.addEventListener('scroll', () => {
        updateArrows();

        if (window.innerWidth > 768) return;
        const cfg = getMobileSwipeConfig();

        track.classList.add('is-lazy-scrolling');
        if (lazySnapTimer) window.clearTimeout(lazySnapTimer);
        lazySnapTimer = window.setTimeout(() => {
          track.classList.remove('is-lazy-scrolling');
          scrollToCardIndex(getNearestCardIndex(), 'smooth');
          updateArrows();
        }, cfg.lazyDelay || 120);
      }, { passive: true });

      // Initial arrow state
      updateArrows();

      // Update on window resize
      window.addEventListener('resize', () => {
        updateArrows();
      }, { passive: true });
      slider.dataset.sliderReady = 'true';
    });
  }

  // Initialize product sliders only when near viewport
  runWhenIdle(() => {
    document.querySelectorAll('[data-product-slider]').forEach((slider) => {
      runWhenVisible(slider, () => {
        initProductSliders();
      });
    });
  });

  // ─── LOAD MORE PRODUCTS (MANUAL) ───
  function initLoadMoreProducts() {
    if (window.Shopify && window.Shopify.designMode) {
      return;
    }

    const loadMoreBtn = document.getElementById('load-more-products-btn');
    if (!loadMoreBtn) return;

    let isLoading = false;

    loadMoreBtn.addEventListener('click', () => {
      if (isLoading) return;

      const revealSplitCardsEvent = new CustomEvent('variantSplit:loadMoreRequested', {
        cancelable: true,
        detail: { pageSize: 12 }
      });
      window.dispatchEvent(revealSplitCardsEvent);
      if (revealSplitCardsEvent.defaultPrevented) {
        return;
      }

      const nextUrl = loadMoreBtn.dataset.nextUrl;
      if (!nextUrl) return;

      isLoading = true;
      loadMoreBtn.disabled = true;
      loadMoreBtn.textContent = 'Carregando...';

      fetch(nextUrl)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          // Extract products from fetched page
          const newProducts = doc.querySelectorAll('#ProductGrid .prod-card');
          const grid = document.getElementById('ProductGrid');

          if (newProducts.length > 0 && grid) {
            const fragment = document.createDocumentFragment();
            newProducts.forEach(product => {
              fragment.appendChild(product.cloneNode(true));
            });
            grid.appendChild(fragment);

            // Reapply wishlist state to new products
            applyWishlistState(grid);
          }

          const newButton = doc.getElementById('load-more-products-btn');
          if (newButton && newButton.dataset.nextUrl) {
            loadMoreBtn.dataset.nextUrl = newButton.dataset.nextUrl;
            loadMoreBtn.disabled = false;
            loadMoreBtn.textContent = 'Carregar mais produtos';
          } else {
            loadMoreBtn.dataset.nextUrl = '';
            loadMoreBtn.disabled = false;
            loadMoreBtn.textContent = 'Carregar mais produtos';

            const hasHiddenVariantCards = document.querySelector('#ProductGrid .variant-split-page-hidden');
            if (!hasHiddenVariantCards) {
              loadMoreBtn.remove();
            }
          }

          isLoading = false;
          window.dispatchEvent(new CustomEvent('variantSplit:syncLoadMoreButton'));
        })
        .catch(err => {
          console.error('Erro ao carregar mais produtos:', err);
          isLoading = false;
          loadMoreBtn.disabled = false;
          loadMoreBtn.textContent = 'Tentar novamente';
        });
    });
  }

  // Initialize manual load more on collection/search pages
  runWhenIdle(() => {
    if (document.getElementById('ProductGrid') && document.getElementById('load-more-products-btn')) {
      initLoadMoreProducts();
    }
  });

  // ─── SHOPIFY THEME EDITOR RELOAD HOOKS ───
  function handleSectionRefresh(e) {
    const root = e && e.target ? e.target : document;
    applyWishlistState(root);
    initBenefitsCarousel();
    initStatsAnimation();

    root.querySelectorAll('[data-carousel]').forEach((carousel) => {
      runWhenVisible(carousel, () => {
        initBannerCarousel();
      });
    });

    root.querySelectorAll('[data-product-slider]').forEach((slider) => {
      runWhenVisible(slider, () => {
        initProductSliders();
      });
    });
  }

  document.addEventListener('shopify:section:load', handleSectionRefresh);
  document.addEventListener('shopify:section:select', handleSectionRefresh);
  document.addEventListener('shopify:block:select', handleSectionRefresh);

})();